export const CompanyInformations = {
  mail: 'contact@qemotion.com',
  mailJob: 'jobs@qemotion.com',
  mailMarketing: 'sebastien.baudet@qemotion.com',
  telephone: '+33 (0)7 84 96 04 36',
  telLink: '+330784960436',
};
